import React from 'react'
import './aritcleApp.css'
import { Input, Icon,message} from 'antd';
import ArticleItemAPP from './articleItem'
import {showErrorMsg} from "../utils/commonFunc";
import {fetchGet} from "../utils/fetchData";
import InfiniteScroll from 'react-infinite-scroller';

class ArticleAPP extends React.Component {
    constructor(props) {
        super(props)
        this.searchText = '';
        this.categoryId = '';
        this.pageNo = 1;
        this.lastSelectBtn = null;
        this.state = {
            arrDataSource :[],
            arrMenu : [],
            hasMore : true,
        }
    }

    componentDidMount() {
        this.props.triggerRef(this)
    }

    expandMenu = () => {
        var expand = document.getElementsByClassName('article_menu_style')[0];
        var article = document.getElementsByClassName('artile_content_style')[0];
        if (expand.style.overflow !== 'visible') {
            expand.style.overflow = 'visible'
            article.style.height = 83 - expand.clientHeight / 32 * 7 + '%'
            article.style.maxHeight = 83 - expand.clientHeight / 32 *7 + '%'
        } else {
            expand.style.overflow = 'hidden'
            article.style.height = 83 + '%'
            article.style.maxHeight = 83 + '%'
        }

        this.claearSearch();
    };

    claearSearch = () => {
        document.getElementById('search').textContent = '';
    };

    handleEnterKey = (event) => {
        this.searchText = event.target.value;
        this.setState({
            arrDataSource : [],
        });
        this.pageNo = 1;
        this.fetchArticleData()
    };

    fetchArticleData = () => {
        let params = {key:this.searchText,menu_id:this.categoryId,page:this.pageNo,size:10};
        fetchGet('article',params,null)
            .then(data => {
                if (data.code === 200) {
                    var datasource = this.state.arrDataSource;
                    let tempSource = datasource.concat(data.data.page_data);
                    var more = data.data.page_data.length >= 10 ? true:false;
                    this.setState({
                        arrDataSource : tempSource ,
                        hasMore:more,
                    });

                }
                else {
                    showErrorMsg(data);
                }
            });
    };

    fetchCategoryMenu = () => {
        fetchGet('wzfl',null,null)
            .then(data => {
                if (data.code === 200) {
                    var category = [{menu_name:'全部',menu_id:''}]
                    for (var i = 0; i < data.data.length; i++) {
                        category.push(data.data[i])
                    }
                    this.setState({
                        arrMenu:category
                    });
                }
                else {
                    showErrorMsg(data);
                }
            });
    };

    clickMenu = (ev,index) => {
        this.pageNo = 1;
        this.setState({
            arrDataSource : [] ,
        });
        if (this.lastSelectBtn != null) {
            this.lastSelectBtn.style.backgroundColor = 'white';
        }
        ev.target.style.backgroundColor = '#688CF5';
        this.lastSelectBtn = ev.target;
        this.categoryId = this.state.arrMenu[index].menu_id;
        this.fetchArticleData(this.searchText,this.categoryId);
    };

    clickArticleItem = (title,content,articleId)=> {
      let params = {article_id: articleId};
      fetchGet('fullArticle',params,null)
          .then(data => {
              console.log(data);
              if (data.code === 200) {

                  this.props.showPreview(title,data.data.article_full,articleId);
              }

          });


    };

    handleInfiniteOnLoad = ()=> {
        this.pageNo ++;
        this.fetchArticleData();
    };

    render(){
        let showExpandBtn = (this.state.arrMenu.length > 5)?'inline-block':'none'
        return(
            <div className='article_mainFrame_style' style={{left:this.props.visible?0+'vw':-96+'vw'}}>
                <div className='article_inner_div_style'>
                    <h2 style={{marginTop : 10 + 'px'}}>文章</h2>

                    <Input onPressEnter={this.handleEnterKey}
                           prefix={<Icon type="search" style={{ color: 'rgba(0,0,0,.25)'}}
                           id='search'/>}
                    />

                    <h4 style={{marginTop : 10 + 'px',color:'gray',display:'block', position:'absolute' }}>分类</h4>
                    <div className='article_menu_style'>{
                        this.state.arrMenu.map((item,index) => {
                            // if (index <  4) {
                                return <button className='article_menu_btn_style' onClick={(ev) => {this.clickMenu(ev,index)}} key={index}>{item.menu_name}</button>
                            // }
                        })
                    }
                    </div>
                    <button style={{display : showExpandBtn}} ref='expand_btn' className='article_menu_btn_expand_style' onClick={this.expandMenu}>展开</button>

                    <div className='artile_content_style'>
                        {
                            <InfiniteScroll
                                initialLoad={false}
                                pageStart={0}
                                loadMore={this.handleInfiniteOnLoad}
                                hasMore={this.state.hasMore}
                                useWindow={false}
                            >{

                                this.state.arrDataSource.map((item, index) => {
                                    return <ArticleItemAPP articleTitle={item.article_name}
                                                           articleContent={item.article_content}
                                                           articleId={item.article_id}
                                                           key={item.article_id}
                                                           clickItem={this.clickArticleItem}/>
                                })
                            }
                            </InfiniteScroll>

                        }
                    </div>


                </div>
            </div>
        );
    }
}

export default ArticleAPP
